import { render, staticRenderFns } from "./aiEmailEditor.vue?vue&type=template&id=06aea177&lang=pug"
import script from "./aiEmailEditor.vue?vue&type=script&lang=js"
export * from "./aiEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./aiEmailEditor.vue?vue&type=style&index=0&id=06aea177&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports